import { Box, useTheme } from "@mui/material";
import { DotLegalHeader, DotLegalTooltip } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "@localization/useTranslation";
import { useRiskAreaTemplateCardStyles } from "./RiskAreaTemplateCard.styles";

export interface RiskAreaTemplateCardProps {
    name: string;
    image: string;
    isAdded?: boolean;
    isCustom?: boolean;
    onClick: () => void;
}

function RiskAreaTemplateCard(props: RiskAreaTemplateCardProps) {
    const theme = useTheme();
    const { translateString } = useTranslation();
    const isAdded = props.isAdded ?? false;
    const isCustom = props.isCustom ?? false;
    const styles = useRiskAreaTemplateCardStyles(theme, props.image, isAdded, isCustom);

    return (
        <DotLegalTooltip text={isAdded ? translateString("riskAreaPresetAlreadyAdded") : ""}>
            <Box sx={styles.card} onClick={() => !isAdded && props.onClick()}>
                <DotLegalHeader headerStyle={"medium"} marginBottom={0} color={isAdded ? "lightgrey" : "primary"} center>
                    {props.name.toUpperCase()}
                </DotLegalHeader>
            </Box>
        </DotLegalTooltip>
    );
}

export default RiskAreaTemplateCard;
